export interface GoalSelectionResponse {
  id: string;
  programId: string;
  name: string;
  theme: string;
  description: string;
  dueDate: string;
  completionDate: string;
  status: string;
  notes: string;
}

export interface GoalSelectionResultRow extends GoalSelectionResponse {
  [key: string]: any;
}

export const GoalSelectionResultFormKey = {
  goalName: "name",
  goalTheme: "theme",
  goalDescription: "description",
  status: "status",
  dueDate: "dueDate",
  completionDate: "completionDate",
  goalNotes: "notes",
};

export type GoalSelectionResultDropdownFilterKey =
  typeof GoalSelectionResultFormKey.status;

export const AddGoalFormKey = {
  name: "name",
  theme: "theme",
  description: "description",
  status: "status",
  dueDate: "dueDate",
  completionDate: "completionDate",
  completionDateWithoutFormatted: "completionDateWithoutFormatted",
  programStartDateWithoutFormatted: "programStartDateWithoutFormatted",
  notes: "notes",
} as const;

export interface AddGoalParams {
  programId: string;
  name: string;
  status: string;
  theme?: string;
  description?: string;
  dueDate?: string | null;
  completionDate?: string | null;
  notes?: string;
}

export interface UpdateGoalParams extends AddGoalParams {
  goalId: string;
}

export interface GoalDetailResponse {
  id: string;
  programId: string;
  name: string;
  status: string;
  theme?: string;
  description?: string;
  dueDate?: string;
  completionDate?: string;
  notes?: string;
}